const aaa = [
	{
		path: "right",
		component: () => import("@/views/control/right.vue"),
		meta:{title:'权限配置'},
	}
]
export default aaa;